export const MAP_CONTAINER_STYLES = {
  position: "absolute",
  top: "60px",
  bottom: "0",
  left: "0",
  right: "0",
  width: "100%",
};
